<template>
  <button
    :disabled="disabled"
    class="button is-primary reset-button"
    @click="resetInterview()"
  >
    Reset Interview
  </button>
</template>

<script>
import { resetPatientQueueToken } from "../../helpers/patient_queue_token";
export default {
  name: "reset-button",

  props: {},

  methods: {
    resetInterview() {
      resetPatientQueueToken();
      this.$router.push({ name: "home" });
    }
  }
};
</script>

<style scoped>
.reset-button {
  margin: 0px auto 0;
  display: inline-block;
  margin-top: 40px !important;
}
</style>
